import React from 'react';
import { Shield, Lock, AlertTriangle, FileCheck, Network, Cloud, CheckCircle } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';

const iconMap = { Shield, Lock, AlertTriangle, FileCheck, Network, Cloud };

export const FrameworksSection = ({ frameworks }) => (
  <section id="frameworks" className="py-12 md:py-16 lg:py-20 bg-slate-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12 md:mb-16">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Our Framework Expertise</h2>
        <p className="text-lg md:text-xl text-slate-600 max-w-2xl mx-auto">
          Deep knowledge of industry-leading security frameworks
        </p>
      </div>
      <div className="space-y-8">
        {frameworks.map((framework) => {
          const Icon = iconMap[framework.icon];
          return (
            <Card key={framework.id} className="border-slate-200">
              <CardHeader>
                <div className="flex items-start space-x-4">
                  <div className="h-12 w-12 bg-[#105EFF]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Icon className="h-6 w-6 text-[#105EFF]" />
                  </div>
                  <div>
                    <CardTitle className="text-2xl text-slate-900">{framework.title}</CardTitle>
                    <CardDescription className="text-lg">{framework.fullName}</CardDescription>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <p className="text-slate-700 mb-6">{framework.description}</p>
                <div className="grid md:grid-cols-2 gap-4">
                  {framework.benefits.map((benefit) => (
                    <div key={benefit} className="flex items-start space-x-2">
                      <CheckCircle className="h-5 w-5 text-[#105EFF] flex-shrink-0 mt-0.5" />
                      <span className="text-slate-700">{benefit}</span>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  </section>
);
